export const RESET = "reset";
export const UPDATE_NOTIFICATIONS = "updateNotifications";
export const ADD_NOTIFICATION = "addNotification";
export const SET_NOTIFICATIONS = "setNotifications";
export const SET_LAST_UPDATED = "setLastUpdated";
